import React from "react";
import { TodoPlaceholder } from "@cms/ui/components/todo-placeholder";

// TO-DO: Implement global settings — API configuration, admin users, feature flags.
export function SettingsPage() {
  return (
    <TodoPlaceholder
      title="Settings"
      description="Admin console configuration: API base URL, admin user management, feature flags, and system-wide defaults. Requires settings API endpoint."
    />
  );
}
